import React, { useState, lazy } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';

import countryMessages from 'Helpers/Geo/CountryNameLocales';
import RegionName from 'Components/Regional/RegionName';
import LazyModal from 'Components/Utility/LazyModal';

import 'Components/Regional/RegionLocked.scss';

const RegionalRestrictionsContainer = lazy(() => import(/* webpackChunkName: "ProductModals" */ 'Features/Product/components/ProductCommerce/RegionalRestrictionsContainer'));


function RegionLocked({ included, excluded, minimal, shortText }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="region-locked">
      <div className="region-locked-content">
        <RegionName
          included={included}
          excluded={excluded}
          countryMessages={countryMessages}
          shortText={shortText}
        />
        <div className="toggle-restictions-toggle-container">
          <button
            className="toggle-restrictions-button"
            onClick={() => setOpen(true)}
          >
            <FormattedMessage id="region-locked.checkcountryrestrictions" defaultMessage="Check Regions" />
          </button>
        </div>
        <LazyModal
          centered
          open={open}
          setOpen={setOpen}
          className="user-tags-modal regional-restrictions-modal"
        >
          <RegionalRestrictionsContainer
            included={included}
            excluded={excluded}
            minimal={minimal}
          />
        </LazyModal>
      </div>
    </div>
  );
}

RegionLocked.propTypes = {
  included: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
    }),
  ),
  excluded: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
    }),
  ),
  minimal: PropTypes.bool,
  shortText: PropTypes.bool,
};

RegionLocked.defaultProps = {
  included: [],
  excluded: [],
  minimal: false,
  shortText: false,
};

export default injectIntl(RegionLocked);
